import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

async function loadAppConfig() {
  try {
    const configUrl = new URL('config.json', window.location.origin).href;
    const response = await fetch(configUrl, { cache: 'no-cache' });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    (window as any)['__APP_CONFIG__'] = await response.json();
  } catch (error) {
    console.error('Error cargando config.json:', error);
    (window as any)['__APP_CONFIG__'] = {
      apiUrl: 'http://localhost:8080/api',
      environmentName: 'local-fallback',
      recaptchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
      guestTokenEndpoint: '/guest/token',
      systems: [],
    };
  } finally {
    return bootstrapApplication(App, appConfig);
  }
}

loadAppConfig().catch((err) => console.error(err));
